document.addEventListener("DOMContentLoaded", () => {

    const slider = document.querySelector(".emvik-slider");

    if (!slider) return;

    const slides = slider.querySelectorAll(".emvik-slide");
    const dots = slider.querySelectorAll(".emvik-dot");
    const prev = slider.querySelector(".emvik-prev");
    const next = slider.querySelector(".emvik-next");

    if (slides.length === 0) return;

    let current = 0;
    let autoPlay;

    function showSlide(index) {

        slides.forEach((slide, i) => {
            slide.classList.toggle("active", i === index);
        });

        dots.forEach((dot, i) => {
            dot.classList.toggle("active", i === index);
        });

        current = index;
    }

    function nextSlide() {
        showSlide((current + 1) % slides.length);
    }

    function prevSlide() {
        showSlide((current - 1 + slides.length) % slides.length);
    }

    function startAuto() {
        stopAuto();
        autoPlay = setInterval(nextSlide, 5000);
    }

    function stopAuto() {
        if (autoPlay) {
            clearInterval(autoPlay);
        }
    }

    /* Initial */

    showSlide(0);

    if (slides.length > 1) {
        startAuto();
    }

    /* Arrows */

    if (next) {
        next.addEventListener("click", () => {
            nextSlide();
            startAuto();
        });
    }

    if (prev) {
        prev.addEventListener("click", () => {
            prevSlide();
            startAuto();
        });
    }

    /* Dots */

    dots.forEach((dot, index) => {
        dot.addEventListener("click", () => {
            showSlide(index);
            startAuto();
        });
    });

    /* Swipe */

    let startX = 0;

    slider.addEventListener("touchstart", e => {
        startX = e.touches[0].clientX;
    }, { passive: true });

    slider.addEventListener("touchend", e => {

        const endX = e.changedTouches[0].clientX;
        const diff = startX - endX;

        if (Math.abs(diff) > 50) {

            if (diff > 0) {
                nextSlide();
            } else {
                prevSlide();
            }

            startAuto();

        }

    }, { passive: true });

    /* Pause on hover */

    slider.addEventListener("mouseenter", stopAuto);

    slider.addEventListener("mouseleave", startAuto);

});